import React, {
  useState, useEffect, useCallback, useMemo,
} from 'react'
import useManageRMADetailComponent from './hooks/useManageRMADetailComponent'

const tabData = ['Return Details', 'Return Confirmation']

const RmaDetails = ({ moduleData }) => {
  const {
    onCancelReturn,
    orderDetails,
  } = { ...moduleData }
  const [data, setData] = useState('')
  const [doneReturn, setDoneReturn] = useState('')
  const [displayReturnDetails, setDisplayReturnDetails] = useState(false)
  const [returnDetailsData, setReturnDetailsData] = useState({})
  const forceMultipleSelect = false

  const cancelReturn = useCallback(() => {
    setData('')
    setDoneReturn('')
    onCancelReturn()
  }, [onCancelReturn])

  useEffect(() => {
    setData(orderDetails)
  }, [orderDetails])

  const consolidatedData = useMemo(() => ({
    ...moduleData,
    cancelReturn,
    data,
    setData,
    doneReturn,
    setDoneReturn,
    displayReturnDetails,
    setDisplayReturnDetails,
    returnDetailsData,
    setReturnDetailsData,
    forceMultipleSelect,
    tabData,
  }), [
    moduleData,
    cancelReturn,
    data,
    setData,
    doneReturn,
    setDoneReturn,
    displayReturnDetails,
    setDisplayReturnDetails,
    returnDetailsData,
    setReturnDetailsData,
    forceMultipleSelect,
  ])

  const Component = useManageRMADetailComponent({
    moduleData: consolidatedData,
  })

  return <Component moduleData={consolidatedData} />
}

export default RmaDetails
